import React from "react";
import classNames from "classnames";
import Loader from "../../Loader";

interface XTimeIFrameProps {
  className: string;
  source?: string;
  onLoad?: Function;
  isLoading?: boolean;
}

interface xTimeIFrameState {
}

class xTimeIFrame extends React.Component<XTimeIFrameProps, xTimeIFrameState> {
  constructor(props: XTimeIFrameProps) {
    super(props);
  }

  render() {

    return (
      <div className="row">
        <iframe
          src={this.props.source}
          className={`${this.props.className}`}
          onLoad={() => this.props.onLoad()}
          frameBorder="0">
        </iframe>
        <Loader isLoading={this.props.isLoading} isPositionRelative={false} />
      </div>
    );
  }
}

export default xTimeIFrame;
